module.exports = __webpack_public_path__ + "img/list.d7f3dd48.svg";